/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useRef, useMemo } from "react";
import { Badge, Button, Input } from "@repo/ui";
import { Link } from "react-router-dom";
import { CirclePlus, CircleX } from "lucide-react";
import { Paths } from "routes/paths";
import { formatExcelTimeToHHMMSS, HasPermission } from "utils/helper";
import { useUser } from "hooks/use-user";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useToast } from "@chakra-ui/react";
import { useLookupCustomers } from "services/lookups-mutations";
import { useExportSlaConf, useImportSlaConf } from "services/notifications";
import * as XLSX from "xlsx";
import { filterBy } from "@progress/kendo-data-query";

export default function FilterBarV2({ getList }) {
  const [filters, setFilters] = useState({});
  const [selectedCashCenter, setSelectedCashCenter] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filter, setFilter] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isImportOpen, setIsImportOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const filterTimeout = useRef(null);
  const user = useUser();
  const toast = useToast();

  const { mutate: getCustomers, data: customersList } = useLookupCustomers();
  const { mutate: exportSlaConf, isPending } = useExportSlaConf();
  const { mutate: importSlaConf, isPending: isImporting } = useImportSlaConf();

  useEffect(() => {
    getCustomers();
  }, []);

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        getList(
          filter || "",
          selectedDate,
          selectedCashCenter || "",
          selectedCustomer || "",
        );
        handleAddFilter("filter", filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) clearTimeout(filterTimeout.current);
    };
  }, [filter]);

  useEffect(() => {
    if (!firstLoad) {
      getList(
        filter || "",
        selectedDate,
        selectedCashCenter || "",
        selectedCustomer || "",
      );
    } else {
      setFirstLoad(false);
    }
  }, [selectedCashCenter, selectedCustomer, selectedDate]);

  const normalizedCustomers = useMemo(
    () => [
      { id: "ALL", name: "All" },
      ...(customersList?.data || []).map((c) => ({
        id: String(c.customerId),
        name: String(c.name),
      })),
    ],
    [customersList],
  );

  const [data, setData] = useState(normalizedCustomers?.slice());

  const filterChange = (event) => {
    setData(filterBy(normalizedCustomers?.slice(), event.filter));
  };

  const handleCustomerChange = (e) => {
    const value = e.value;
    const hasAll = value.some((v) => v.id === "ALL");
    setSelectedCustomers(hasAll ? [normalizedCustomers[0]] : value);
  };

  const handleExport = () => {
    let payload = {};

    if (selectedCustomers.length > 0 && selectedCustomers[0]?.id !== "ALL") {
      payload = {
        customerIds: selectedCustomers.map((c) => c.id),
      };
    }

    exportSlaConf(payload, {
      onSuccess: (res) => {
        const data = res?.data || [];

        if (!data.length) {
          toast({
            title: "No data found",
            description: "No data exists for the selected fields",
            status: "info",
            isClosable: true,
          });
          return;
        }

        const customerRows = [];
        const contractSlaRows = [];
        const serviceWindowRows = [];
        const lastCallRows = [];
        const locationInitials = [];

        data.forEach((customer) => {
          // Customer sheet
          customerRows.push({
            "Client ID": customer.clientId,
            "Customer Name": customer.customerName,
            "Short Name": customer.shortName,
            "Customer Code": customer.customerCode,
            "Customer Type": customer.customerType,
            Status: customer.status,
          });

          customer.contracts?.forEach((contract) => {
            contract.ContractSLAs?.forEach((sla) => {
              contractSlaRows.push({
                CustomerName: customer.customerName,
                ContractCode: contract.ContractCode,
                ContractStatus: contract.Status,
                AutoRenewFor: contract.AutoRenewFor,
                StartDate: contract.StartDate,
                EndDate: contract.EndDate,
                City: sla.City,
                // ServiceType: sla.ServiceType,
                ActivityType: sla.ActivityType,
                ResponseTime: sla.ResponseTime,
                // AttendedTime: sla.AttendedTime,
                ResolutionTime: sla.ResolutionTime,
              }) || [];
            });
          });
          if (!contractSlaRows || !contractSlaRows?.length) {
            contractSlaRows.push({
              CustomerName: "",
              ContractCode: "",
              ContractStatus: "",
              AutoRenewFor: "",
              StartDate: "",
              EndDate: "",
              City: "",
              // ServiceType: sla.ServiceType,
              ActivityType: "",
              ResponseTime: "",
              // AttendedTime: sla.AttendedTime,
              ResolutionTime: "",
            });
          }

          customer.customerServiceWindows?.forEach((sw) => {
            serviceWindowRows.push({
              CustomerName: customer.customerName,
              City: sw.City,
              // ServiceType: sw.ServiceType,
              ActivityType: sw.ActivityType,
              StartTime: sw.StartTime,
              EndTime: sw.EndTime,
            });
          });
          if (!serviceWindowRows || !serviceWindowRows?.length) {
            serviceWindowRows.push({
              CustomerName: "",
              City: "",
              ActivityType: "",
              StartTime: "",
              EndTime: "",
            });
          }

          customer.lastCallTimings?.forEach((lc) => {
            lastCallRows.push({
              CustomerName: customer.customerName,
              City: lc.City,
              LastCallTimeVaultAccessRequired:
                lc.LastCallTimeVaultAccessRequired,
              LastCallTimeNoVaultAccessRequired:
                lc.LastCallTimeNoVaultAccessRequired,
            });
          });
          if (!lastCallRows || !lastCallRows?.length) {
            lastCallRows.push({
              CustomerName: "",
              City: "",
              LastCallTimeVaultAccessRequired: "",
              LastCallTimeNoVaultAccessRequired: "",
            });
          }

          customer.locationInitials?.forEach((lc) => {
            locationInitials.push({
              CustomerName: customer.customerName,
              InitialType: lc.InitialType,
              InitialValue: lc.InitialValue,
            });
          });
          if (!locationInitials || !locationInitials?.length) {
            locationInitials.push({
              CustomerName: "",
              InitialType: "",
              InitialValue: "",
            });
          }
        });

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.json_to_sheet(customerRows),
          "Customer",
        );
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.json_to_sheet(contractSlaRows),
          "Contract SLAs",
        );
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.json_to_sheet(serviceWindowRows),
          "Service Windows",
        );
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.json_to_sheet(lastCallRows),
          "Last Call Timings",
        );

        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.json_to_sheet(locationInitials),
          "Location Initials",
        );
        XLSX.writeFile(workbook, "Customers_Detail.xlsx");

        toast({
          title: "Export successful",
          status: "success",
          isClosable: true,
        });
      },
      onError: (err) => {
        toast({
          title: "Export failed",
          description: err.message || "Something went wrong",
          status: "error",
          isClosable: true,
        });
      },
    });
  };

  const handleImportFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
  };

  const handleUploadImport = () => {
    if (!selectedFile) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, {
        type: "binary",
      });

      const customerSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Customer"] || [],
      );

      const contractSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Contract SLAs"] || [],
      );

      const serviceWindowSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Service Windows"] || [],
      );

      const lastCallSheet = XLSX.utils.sheet_to_json(
        workbook.Sheets["Last Call Timings"] || [],
      );

      const locationInitials = XLSX.utils.sheet_to_json(
        workbook.Sheets["Location Initials"] || [],
      );

      const customersMap = {};

      customerSheet.forEach((cust) => {
        customersMap[cust["Customer Name"]] = {
          clientId: `${cust["Client ID"]}`,
          contractCode: "",
          contractSLAs: [],
          serviceWindows: [],
          lastCallTimings: [],
          locationInitials: [],
        };
      });

      contractSheet.forEach((row) => {
        const customer = customersMap[row.CustomerName];
        if (!customer) return;

        customer.contractCode = row.ContractCode;

        customer.contractSLAs.push({
          city: row.City,
          // serviceType: row.ServiceType,
          activityType: row.ActivityType,
          responseTime: row.ResponseTime,
          attendedTime: row.AttendedTime || 0,
          resolutionTime: row.ResolutionTime,
        });
      });

      serviceWindowSheet.forEach((row) => {
        const customer = customersMap[row.CustomerName];
        if (!customer) return;

        customer.serviceWindows.push({
          city: row.City,
          // serviceType: row.ServiceType,
          activityType: row.ActivityType,
          startTime: formatExcelTimeToHHMMSS(row.StartTime),
          endTime: formatExcelTimeToHHMMSS(row.EndTime),
        });
      });

      lastCallSheet.forEach((row) => {
        const customer = customersMap[row.CustomerName];
        if (!customer) return;

        customer.lastCallTimings.push({
          city: row.City,
          lastCallTimeVaultAccessRequired: formatExcelTimeToHHMMSS(
            row.LastCallTimeVaultAccessRequired,
          ),
          lastCallTimeNoVaultAccessRequired: formatExcelTimeToHHMMSS(
            row.LastCallTimeNoVaultAccessRequired,
          ),
        });
      });

      locationInitials.forEach((row) => {
        const customer = customersMap[row.CustomerName];
        if (!customer) return;

        customer.locationInitials.push({
          CustomerName: row.customerName,
          InitialType: row.InitialType,
          InitialValue: String(row.InitialValue),
        });
      });

      const payload = {
        customers: Object.values(customersMap),
      };

      importSlaConf(payload, {
        onSuccess: () => {
          toast({
            title: "Import successful",
            status: "success",
            isClosable: true,
          });

          setSelectedFile(null);
          setIsImportOpen(false);
        },
        onError: (err) => {
          toast({
            title: "Import failed",
            description: err.message || "Something went wrong",
            status: "error",
            isClosable: true,
          });
        },
      });
    };

    reader.readAsBinaryString(selectedFile);
  };

  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];

    if (key === "cashCenter") setSelectedCashCenter("");
    if (key === "customer") setSelectedCustomer("");
    if (key === "date") setSelectedDate(new Date());
    if (key === "filter") setFilter("");

    setFilters(updatedFilter);
  };

  const handleAddFilter = (key, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }
    setFilters((prev) => ({
      ...prev,
      [key]: `${name}: ${value}`,
    }));
  };

  const clearAllFilters = () => {
    setFilters({});
    setSelectedCashCenter("");
    setSelectedCustomer("");
    setSelectedDate(new Date());

    setFilter("");
  };

  const canCreateNewCustomer = useMemo(
    () => HasPermission(user, "Customer", "Add"),
    [user],
  );

  return (
    <>
      {/* Top Bar */}
      <div className="flex mb-3 gap-2">
        <div className="flex-1">
          <Input
            value={filter}
            placeholder="Search"
            title="Search"
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
        {canCreateNewCustomer ? (
          <div className="flex gap-2">
            <Link to={Paths.addCustomer}>
              <Button variant="secondary" className="flex gap-2">
                <CirclePlus />
                Create Customer
              </Button>
            </Link>

            <div className="relative">
              <Button
                variant="secondary"
                onClick={() => setIsDropdownOpen((prev) => !prev)}
              >
                Bulk Operations
              </Button>

              {isDropdownOpen ? (
                <div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow-md z-50">
                  <div
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setIsExportOpen(true);
                      setIsDropdownOpen(false);
                    }}
                  >
                    Download Excel
                  </div>

                  <div
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setIsImportOpen(true);
                      setIsDropdownOpen(false);
                    }}
                  >
                    Upload Excel
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      <div className="flex mb-3 gap-2 flex-wrap items-end">
        {Object.entries(filters).map(([key, value]) => (
          <Badge
            key={key}
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
          >
            {value}
            <CircleX onClick={() => handleClearFilter(key)} />
          </Badge>
        ))}

        {Object.keys(filters).length > 0 && (
          <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
            Clear All
            <CircleX onClick={clearAllFilters} />
          </Badge>
        )}
      </div>

      {/* Export Popup */}
      {isExportOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg p-5 w-[360px] space-y-4">
            <h3 className="text-lg font-semibold">Export Customers Detail</h3>

            <MultiSelect
              data={data}
              filterable
              onFilterChange={filterChange}
              textField="name"
              dataItemKey="id"
              placeholder="Select Customers"
              value={selectedCustomers}
              onChange={handleCustomerChange}
              className="w-full"
            />

            <div className="flex justify-end gap-2">
              <Button
                variant="secondary"
                onClick={() => setIsExportOpen(false)}
              >
                Cancel
              </Button>

              <Button
                variant="secondary"
                disabled={isPending}
                onClick={() => {
                  handleExport();
                  setIsExportOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      ) : null}
      {isImportOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg p-5 w-[400px] space-y-4">
            <h3 className="text-lg font-semibold">Import Customers Detail</h3>

            <input
              type="file"
              accept=".xlsx, .xls"
              ref={fileInputRef}
              onChange={handleImportFile}
            />

            {selectedFile ? (
              <p className="text-sm text-gray-600">
                Selected: {selectedFile.name}
              </p>
            ) : null}

            <div className="flex justify-end gap-2">
              <Button
                variant="secondary"
                onClick={() => {
                  setIsImportOpen(false);
                  setSelectedFile(null);
                }}
              >
                Cancel
              </Button>

              {selectedFile ? (
                <Button
                  variant="secondary"
                  disabled={isImporting}
                  onClick={handleUploadImport}
                >
                  {isImporting ? "Uploading..." : "Upload"}
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
